import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { setCredentials } from "./authSlice";
import { useLoginMutation } from "./authApiSlice";
import { showLoader, hideLoader } from "../../app/api/appApiSlice";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [login, { isSuccess, isError }] = useLoginMutation();

  const [username, setUsername] = useState("");
  const [errUsername, setErrUsername] = useState(false);
  const [password, setPassword] = useState("");
  const [errPassword, setErrPassword] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  let token = null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username) {
      setErrUsername(true);
    }

    if (!password) {
      setErrPassword(true);
    }

    if (!username || !password) {
      return false;
    }

    try {
      dispatch(showLoader());
      const { accessToken } = await login({ username, password }).unwrap();
      token = accessToken;
    } catch (err) {
      if (err.data?.message) {
        setErrMsg(err.data?.message);
      } else {
        setErrMsg("Please try again later.!");
      }
    }
  };

  useEffect(() => {
    if (isSuccess) {
      setErrMsg("");

      setTimeout(async () => {
        setUsername("");
        setPassword("");

        dispatch(setCredentials({ accessToken: token }));

        dispatch(hideLoader());

        navigate("/home");
      }, 3000);
    }

    if (isError) {
      dispatch(hideLoader());
    }
  }, [isSuccess, isError]);

  return (
    <>
      <section className="flex items-center justify-center xs:min-h-[calc(100vh-68px)] py-10 mx-auto">
        <div className="flex items-center justify-center flex-wrap gap-16 sm:gap-40 p-4 xs:p-8 sm:p-20 mx-auto rounded-xl xs:shadow-lg">
          <div className="text-center">
            <img
              className="w-[300px] mx-auto mb-4"
              src="/img/dashboard.png"
              alt="intro image"
            />
            <p className="text-base sm:text-2xl">
              If you don't have an account?
              <br />
              Please go to the signup page.
            </p>
            <div className="mt-4">
              <Link
                className="inline-block bg-black text-white uppercase p-3 rounded-md"
                to="/signup"
              >
                Sign Up
              </Link>
            </div>
          </div>
          <div className="flex flex-col justify-center xs:justify-start w-[300px] max-w-[calc(100%-30px)]">
            <h1 className="text-3xl text-center uppercase mb-6">Sign In</h1>
            <form method="post" onSubmit={handleSubmit}>
              <div className="mb-4">
                <div
                  className={`py-[10px] px-[12px] border-[1px] rounded-md ${
                    errUsername && "text-error border-error"
                  }`}
                >
                  <label htmlFor="username" className="block text-xs">
                    Username *
                  </label>
                  <input
                    id="username"
                    name="username"
                    type="email"
                    className="focus-visible:outline-none"
                    value={username}
                    onChange={(e) => {
                      setUsername(e.target.value);
                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      if (!emailRegex.test(e.target.value)) {
                        setErrUsername(true);
                      } else {
                        setErrUsername(false);
                      }
                    }}
                    autoComplete="false"
                  />
                </div>
                {errUsername && (
                  <span className="text-xs text-error">
                    Please enter a valid email address.
                  </span>
                )}
              </div>
              <div
                className={`py-[10px] px-[12px] mb-4 border-[1px] rounded-md ${
                  errPassword && "text-error border-error"
                }`}
              >
                <label htmlFor="password" className="block text-xs">
                  Password *
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder=""
                  className="focus-visible:outline-none"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (e.target.value) {
                      setErrPassword(false);
                    } else {
                      setErrPassword(true);
                    }
                  }}
                  autoComplete="false"
                />
              </div>
              <Link to="/forget-password" className="text-sm underline">
                Forget password?
              </Link>
              <div className="text-center mt-4">
                <button
                  type="submit"
                  className="max-w-fit bg-black text-white uppercase p-3 rounded-md"
                >
                  Sign In
                </button>
              </div>
              {errMsg && (
                <div className="max-w-max text-center text-error py-2 px-4 mt-4 mx-auto rounded-md">
                  {errMsg}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
